module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_umeda-b1624eb9f3bf14ebb1f6b5075c695a1b.jpg";